import React from 'react';
import PropTypes from 'prop-types';
import { makeCss, PaginatedDataTable } from '../../../../knock-design-system';
import { ErrorState } from './ErrorState';
import { getColumnConfig, stylesConfig } from './getColumnConfig';
import { PAGINATION_DEFAULTS } from '../constants';

const useCss = makeCss((theme) => ({
  syndicationDataTable: {
    '& .MuiTableBody-root .MuiTableRow-root:first-of-type:last-child > .MuiTableCell-root':
      {
        borderBottom: `1px solid ${theme.palette.slate[200]}`,
      },
    '& .MuiTableCell-head.MuiTableCell-paddingCheckbox:first-of-type': {
      backgroundColor: theme.palette.background.field,
    },
  },
}));

export const ROW_SELECTION_KEY = 'property';

const SyndicationDataTable = ({
  errorMessage,
  filteredChannels,
  getSyndication,
  isLoading,
  propertiesSyndication,
  selectedProperties,
  setSelectedProperties,
  totalPropertyCount,
  updatePropertySyndication,
}) => {
  const css = useCss();

  const handlePropertySelectionOnChange = (newSelectedRows) => {
    setSelectedProperties(newSelectedRows);
  };

  const handleChannelOnChange = (propertyId, channelId) => (e) => {
    const { checked: isChecked } = e.target;
    const channelUpdate = { [channelId]: isChecked };
    updatePropertySyndication(propertyId, channelUpdate);
  };

  const { columns, columnRenderers } = getColumnConfig({
    filteredChannels,
    handleChannelOnChange,
  });

  const selectedRowsText = `${selectedProperties.length} of ${totalPropertyCount} properties selected`;

  return (
    <PaginatedDataTable
      columns={columns}
      columnRenderers={columnRenderers}
      css={css.syndicationDataTable}
      data={propertiesSyndication}
      dataRowId={ROW_SELECTION_KEY}
      defaultRowsPerPage={PAGINATION_DEFAULTS.ROWS_PER_PAGE}
      defaultSortColumn={PAGINATION_DEFAULTS.SORT_COLUMN}
      errorFallback={<ErrorState title={errorMessage} />}
      getTableData={getSyndication}
      isError={Boolean(errorMessage)}
      isLoading={isLoading}
      onSelectRow={handlePropertySelectionOnChange}
      paginationMessage={selectedRowsText}
      rowsPerPageOptions={PAGINATION_DEFAULTS.ROWS_PER_PAGE_OPTIONS}
      selectedRows={selectedProperties}
      stickyColumnsLeft={1}
      stickyHeader
      stylesConfig={stylesConfig}
      totalDataRowCount={totalPropertyCount}
    />
  );
};

SyndicationDataTable.propTypes = {
  errorMessage: PropTypes.string,
  filteredChannels: PropTypes.arrayOf(
    PropTypes.shape({
      channelId: PropTypes.string,
      channelName: PropTypes.string,
    })
  ),
  getSyndication: PropTypes.func,
  isLoading: PropTypes.bool,
  propertiesSyndication: PropTypes.arrayOf(PropTypes.shape({})),
  selectedProperties: PropTypes.arrayOf(PropTypes.shape({})),
  setSelectedProperties: PropTypes.func,
  totalPropertyCount: PropTypes.number,
  updatePropertySyndication: PropTypes.func,
};

export default SyndicationDataTable;
